import {Vue, Component, Watch} from 'vue-property-decorator';
import {AxiosPromise, CancelTokenSource} from 'axios';
import {difference, flattenDeep, cloneDeep} from 'lodash';
import {EventDefaultValues} from '@/views/system/measurements/interfaces';

@Component
export default class EditDialogMixin extends Vue {
  protected dialog = false;
  protected loading = false;
  protected saving = false;
  protected cancelRequest: CancelTokenSource | null = null;
  protected options: any = null;
  protected data: any = null;

  protected moduleDefaultValues: EventDefaultValues[] = [];

  protected valid = true;
  private errors: {
    [key: string]: Array<string>;
  } | null = null;
  public errorKeyList: {
    [key: string]: string;
  } | null = null;

  get commonErrors() {
    if (this.errorKeyList && this.errors) {
      const commonKeys = difference(Object.keys(this.errors), Object.values(this.errorKeyList));
      if (commonKeys.length > 0)
        return flattenDeep(commonKeys.map(key => (this.errors as any)[key]));
    } else if (this.errors) return flattenDeep(Object.values(this.errors));
    return null;
  }

  @Watch('dialog')
  onValueChange(value: boolean) {
    if (value)
      this.$nextTick().then(() => {
        this.onClickOutside();
      });
  }

  open(data: any, options: any) {
    this.options = options;
    this.init(data);
    this.dialog = true;
  }

  async openAsync(request: AxiosPromise, cancelRequest: CancelTokenSource, options: any) {
    this.dialog = true;
    this.cancelRequest = cancelRequest;
    this.options = options;
    const timerId = setTimeout(() => {
      this.loading = true;
    }, 100);
    try {
      const {data} = await request;
      this.init(data);
    } catch (err) {
      this.setupErrors({error: 'Произошла ошибка'});
    } finally {
      clearTimeout(timerId);
      this.loading = false;
    }
  }

  save() {
    const form = this.$refs.form as any;
    if (!form) {
      console.warn('form ref not found at validation state');
    }
    this.valid = form.validate();
    if (this.valid) {
      const data = cloneDeep(this.data);
      if (typeof this.options.saveCallback == 'function') {
        this.saving = true;
        this.options.saveCallback(data);
      } else {
        console.warn('no saveCallback provided');
        this.close();
      }
    }
  }

  close() {
    this.dialog = false;
    if (this.loading && this.cancelRequest) {
      this.cancelRequest.cancel();
      this.cancelRequest = null;
    }
    setTimeout(() => {
      this.loading = false;
      this.options = null;
      this.saving = false;
      this.valid = true;
      this.errors = null;
      this.clear();
    }, 175);
  }

  init(data: any) {
    this.data = data;
  }

  clear() {
    this.moduleDefaultValues = [];
    this.data = null;
  }

  onClickOutside() {
    const focusable = Array.from(document.querySelectorAll('.v-dialog__content'));
    const active = focusable.find(el => el.classList.contains('v-dialog__content--active'));
    active && (active as HTMLElement).focus();
  }

  setupErrors(errors: any) {
    this.errors = errors;
    this.saving = false;
  }
}
